import { useCallback, useEffect, useRef, useState } from 'react';

const useHorizontalScrollFade = (enabled: boolean, deps: unknown[] = []) => {
  const [showFade, setShowFade] = useState(false);

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  const updateFade = useCallback(() => {
    const el = scrollContainerRef?.current;

    const remaining = el.scrollWidth - el.clientWidth - el.scrollLeft;

    setShowFade(remaining > 1);
  }, []);

  useEffect(() => {
    const el = scrollContainerRef?.current;

    if (!enabled || !el) {
      setShowFade(false);
      return;
    }

    updateFade();

    el.addEventListener('scroll', updateFade, { passive: true });
    window.addEventListener('resize', updateFade);

    return () => {
      el.removeEventListener('scroll', updateFade);
      window.removeEventListener('resize', updateFade);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, ...deps]);

  return { showFade, scrollContainerRef };
};

export default useHorizontalScrollFade;
